module.exports = __webpack_public_path__ + "img/Aviation_mob_1.da72bd5c.jpg";